import { Injectable } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { HttpErrorResponse, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
// import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class HandleErrorService {

  handleError(error) {
    // console.log(error);
    let errorMessage = '';
    if (error.error instanceof ErrorEvent || error.error instanceof Blob) {
      // client-side error
      errorMessage = `${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `${error.message}`;
    }
    return throwError(errorMessage);
  }

  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    // console.log(err);
    const reader: FileReader = new FileReader();

    const obs = Observable.create((observer: any) => {
      reader.onloadend = (e) => {
        observer.error(JSON.parse(e.srcElement['result']));
        observer.complete();
      };
    });
    reader.readAsText(err.error);
    return obs;
  }

}
